import FILTER_TYPES from '@/components/query/filter-types';
import FILTER_SOURCE_TYPES from '@/components/query/filter-source-type';
import _ from '@/common/helpers';

export default {
    id: 'lists',
    version: 1,
    filterSpec: {
        id: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'lists',
                labelBuilder: ({id, name}) => `${_.truncate(id, {limit: 11, dots: false})}-${name}`,
                value: 'id',
            },
        },
        name: {
            type: FILTER_TYPES.text,
        },
        createdTime: {
            type: FILTER_TYPES.datetime,
        },
        updatedTime: {
            type: FILTER_TYPES.datetime,
        },
    },
};
